import Head from 'next/head';
import { ModalCode } from '@/components/codeHighlights/ModalCode';
import { Modal } from '@/components/Modal';
const Page = () => {
  return (
    <>
      <Head>
        <title>Modal</title>
      </Head>

      <h1>Modal</h1>

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      >
        Launch demo modal
      </button>

      <div className="mt-5">
        <ModalCode />
      </div>

      <Modal title={'Modal title'} text={'Modal content goes here ...'} />
    </>
  );
};

export default Page;
